import "./GroupProject.css";

import { useNavigate, useSearchParams } from "react-router-dom";

import { getPlaceholderImage } from "../../../../../utils";
import { getPublicProjectOverviewRoute } from "../../../../../utils/routes";
import { DeveloperProject } from "../../../usePublicProjectTemplate";

interface GroupProjectProps {
  project: DeveloperProject;
}

export const GroupProject = ({ project }: GroupProjectProps): JSX.Element => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (
    <button
      className="GroupProject"
      onClick={() => {
        navigate(`${getPublicProjectOverviewRoute(project.uuid)}?${searchParams}`);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      <img src={project.image ?? getPlaceholderImage(project.codeName)} alt={project.displayName} />
      <div className="GroupProjectDetails">
        <h4>{project.displayName}</h4>
        {project.description && <p className="body3 GroupProjectDescription">{project.description}</p>}
      </div>
    </button>
  );
};
